import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Alert } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import { VendorSetIDDropdown } from '../components/VendorSetIDDropdown';
import TimedDisplay from '../components/TimedDisplay';
import { Loading } from "./Loading";
import '../styles/NotificationForm.css';

export default function NewNotificationForm(props) {
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("Error");
    const [currentAudience, setCurrentAudience] = useState("");
    const [addMsg, setAddMsg] = useState("");
    const [addMsgLevel, setAddMsgLevel] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [hasWarning, setHasWarning] = useState(false);
    const [characterCount, setCharacterCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isAudiencesReady, setIsAudiencesReady] = useState(false);
    const maxLength = 512;
    useEffect(() => {
      
        console.log(`New Notif Audiences are now ${isAudiencesReady}`);
        if (isAudiencesReady === true) {
            loadForm(isAudiencesReady);
        }
        
    }, [isAudiencesReady]);

    function loadForm(isReady) {
        if (isReady === true) {
            console.log(`Load Form is READY`);
            setIsLoading(false);
        }
    }
    function addNotification(message, severity, audience) {
        props.setIsLoading(true);
        const notification = { message: message, severity: severity, enabled: true, audience: audience, visible: true };

        ServiceCalls.addSiteNotification(notification).then(function (data) {
            if (data.notificationId > 0) {
                sessionStorage.setItem("curNotif", data.notificationId);

                setAddMsg(`Successfully added ${severity === "Error" ? "Alert" : severity} notification`);
                setAddMsgLevel('info');
                props.onNotificationAdded(data.notificationId);
            }
            else {
                setAddMsg(`Failed to add ${severity === "Error" ? "Alert" : severity} message`);
                setAddMsgLevel('danger');

            }
        });
    }

    function showAlertMessage() {
        if (addMsg && addMsgLevel && submitting) {
            return (<TimedDisplay delay="3000" callback={resetForm}>
                <Alert variant={addMsgLevel}>{addMsg}</Alert>
            </TimedDisplay>);
        }
        else {
            return (<></>);
        }
    }

    function resetForm() {
        setAddMsgLevel("");
        setAddMsg("");
        setSubmitting(false);
        setMessage("");
        setSeverity("Error");
        setIsValid(true);
        setHasWarning(false);
        setCurrentAudience("");
    }

    function specialCharCheck(input) {
        var regex = /^[^&<>""'/$^]*$/;
        return regex.test(input);
    }

    function selectAudience(val) {
        console.log(`Setting Audience to ${val}`);
        //Show warning if Admin selects an audience with a currently active notification
        var hasActive = props.notificationList.some(n => n.audience === val && n.enabled === true);
        console.log(`Audience ${val} ${(hasActive) ? 'HAS' : "DOES NOT HAVE"} an ACTIVE notification`);
        setHasWarning(hasActive);
        var curAudience = currentAudience;
        setCurrentAudience(val);
        //Reset Validity
        if (isValid === false && curAudience === "") {
            setIsValid(true);
        }
    }

    const handleSubmit = event => {
        event.preventDefault();
        if (message.trim() === '' || !specialCharCheck(message) || !(currentAudience)) {
            setIsValid(false);
        } else {
            setIsValid(true);
            setSubmitting(true);
            setHasWarning(false);

            addNotification(message, severity, currentAudience);
            event.target.reset();
            setCharacterCount(0);
            resetForm();
        }
    }

    //US7387652 - remove the abolity to disable all active
    //const handleDisable = event => {
    //    event.preventDefault();
    //    props.handleDisable();
    //}
    const onAudienceReady = (status) => {
        console.log(`New Notif Audience Status Change are now ${status}`)
        setIsAudiencesReady(status)
    }

    const setNotifMessage = (message) => {
        setMessage(message);
        setCharacterCount(message.length);
        setIsValid(true);
    }

    return (
        (isLoading)
            ? <Container as={Form} fluid className="adminNotificationContainer borderCurve">
                <Row>
                    <Col sm={6}>
                        <h3 className="notificationHdr">Enter a New Notification</h3>
                      
                    </Col>
                    <Col sm={3}>
                        <label className="form-label" htmlFor="formSeverity">
                            Select Severity
                        </label>
                        <select name="severity" id="formSeverity" className="form-control form-select form-control" onChange={(e) => setSeverity(e.target.value)}>
                            <option className="notificationAlert" value="Error">Alert</option>
                            <option className="notificationAlert" value="Informational" defaultValue>Informational</option>
                        </select>
                    </Col>
                    <VendorSetIDDropdown onChange={selectAudience} colSize={3} onListLoaded={onAudienceReady} currentAudience={currentAudience} />
                </Row>
            </Container>
        :<Container as={Form} id="new-notif-form" fluid className="adminNotificationContainer borderCurve" onSubmit={handleSubmit}>
            <Row>
                <Col sm={6}>
                    <h3 className="notificationHdr">Enter a New Notification</h3>
                    {submitting}
                </Col>
                <Col sm={3}>
                    <label className="form-label" htmlFor="formSeverity">
                        Select Severity
                    </label>
                    <select name="severity" id="formSeverity" className="form-control form-select form-control" onChange={(e) => setSeverity(e.target.value)}>
                        <option className="notificationAlert" value="Error">Alert</option>
                        <option className="notificationAlert" value="Informational" defaultValue>Informational</option>
                    </select>
                </Col>
                <VendorSetIDDropdown onChange={selectAudience} colSize={3} onListLoaded={onAudienceReady} currentAudience={currentAudience} />
            </Row>
            <Row className="notificationTextArea">
                <Col sm={12}>        
                            <textarea
                                name="message"
                                onChange={(e) => setNotifMessage(e.target.value)}
                                className="textbox-notif"
                                placeholder=" Enter notification message"
                                maxLength={maxLength}
                            />
                            <div id="text-count">
                                <span id="current">{characterCount}</span>
                                <span id="maximum">/{maxLength}</span>
                                {isValid ? <></> : <span className='invalid'>&nbsp;&nbsp;Supplier Set ID must be selected and message cannot be blank or contain special characters.</span>}
                    </div>
                </Col>
            </Row>
            <Row>              
                <Col sm={9}>
                    {(hasWarning) ? <div className="notificationWarning"> Selected Supplier Set ID already has active notification.  Submitting will inactivate the current one.</div> : <></>}
                    {showAlertMessage()}
                </Col>
                <Col sm={3} className='notification-form-buttons'>
                    {(submitting || !isAudiencesReady) ? <></> : <button type="submit" className="submit-button">Add New</button>}
                    {/* US7387652 - Remove the ability to
                     disable all actives {(submitting || !audienceReady) ? <></> : <button type="button" className="preview-button" onClick={handleDisable}>Disable All</button>}
                  */}
                </Col>
            </Row>
        </Container>
    )
}